import { render, staticRenderFns } from "./badWait.vue?vue&type=template&id=30135684&scoped=true&"
import script from "./badWait.vue?vue&type=script&lang=js&"
export * from "./badWait.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30135684",
  null
  
)

export default component.exports